export default {
  methods: {
    listen (target, eventType, callback) {
      if (!this._eventRemovers) {
        this._eventRemovers = []
      }
      target.addEventListener(eventType, callback)
      this._eventRemovers.push({
        remove: function () {
          target.removeEventListener(eventType, callback)
        }
      })
    }
  },
  destroyed () {
    if (this._eventRemovers) {
      this._eventRemovers.forEach(function (eventRemover) {
        eventRemover.remove()
      })
    }
  },
  computed: {
    // 透明色ありのプリセットカラー
    defaultColors () {
      let defaultColors = this.borderColors
      defaultColors.push('transparent')
      return defaultColors
    },
    // 透明色なしのプリセットカラー：罫線色で使用
    borderColors () {
      const borderColors = [
        '#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321',
        '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2',
        '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF',
      ]
      return borderColors
    },
  }
}
